export default __webpack_public_path__ + "static/levi-midnight-b5a2317511b65c91ed6bf01e34a3b472.jpg";